import { post } from "../../services";
import {
    ACTIVATE_MOKSHA_ROOMTYPE_RATE,
    ACTIVATE_PROPERTY_OFFER,
    ACTIVATE_ROOMTYPE_OFFER,
    ACTIVATE_ROOMTYPE_OTA_COUNT,
    ADD_MOKSHA_ROOMTYPE_RATE,
    ADD_NEW_PROPERTY_OFFER,
    ADD_ROOMTYPE_OFFER,
    ADD_ROOMTYPE_OTA_COUNT,
    CHECK_PROPERTY_OFFER_RATES,
    CHECK_ROOMTYPE_OFFER_RATES,
    LIST_ALL_PROPERTY_OFFERS,
    LIST_ALL_ROOMTYPE_OFFERS,
    LIST_ALL_ROOMTYPE_OTA_COUNT,
    LIST_MOKSHA_ROOMTYPE_RATES,
    SYNC_PROPERTY_OFFER,
    SYNC_ROOMTYPE_OFFER,
    SYNC_ROOMTYPE_OTA_COUNT,
    UPDATE_DEFAULT_MEAL_PLAN,
    UPDATE_MOKSHA_ROOMTYPE_RATE,
    UPDATE_PROPERTY_OFFER,
    UPDATE_ROOMTYPE_OFFER,
} from "../../graphql";
import {
    RESET_ALL_PROPERTY_OFFERS,
    RESET_ALL_ROOMTYPE_OFFERS,
    RESET_ALL_ROOMTYPE_OTA_COUNT,
    SAVE_ALL_PROPERTY_OFFERS,
    SAVE_ALL_ROOMTYPE_OFFERS,
    SAVE_ALL_ROOMTYPE_OTA_COUNT,
    SAVE_ROOMTYPE_DETAILS,
    TOGGLE_LOADING,
} from "../types";
import { toast } from "react-toastify";

export const listAllRoomtypeOffers = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const {
            offers: { pageSize, pageNumber, list },
        } = getState().roomtypes;

        let apiResponse = await post("", {
            query: LIST_ALL_ROOMTYPE_OFFERS,
            variables: {
                pageSize: pageSize,
                pageNumber: pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_roomtype_offers: { data, hasMore },
            } = apiResponse.data.data;
            let updatedList = [...list, ...data];

            dispatch({
                type: SAVE_ALL_ROOMTYPE_OFFERS,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: pageNumber + 1,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllRoomtypeOffers = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_ROOMTYPE_OFFERS });
    };
};

export const addRoomtypeOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_ROOMTYPE_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomtypeOffers());
            dispatch(listAllRoomtypeOffers({ roomtypeId:requestData.roomtypeId }));
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const updateRoomtypeOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_ROOMTYPE_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomtypeOffers());
            dispatch(listAllRoomtypeOffers({ roomtypeId:requestData.roomtypeId }));
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const checkOfferRates = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: CHECK_ROOMTYPE_OFFER_RATES,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                check_roomtype_offer_rates: { data },
            } = apiResponse.data.data;
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return data;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const activateRoomtypeOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ACTIVATE_ROOMTYPE_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomtypeOffers());
            dispatch(listAllRoomtypeOffers({ roomtypeId:requestData.roomtypeId }));
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listAllRoomtypeOtaCount = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const {
            otaCounts: { pageSize, pageNumber, list },
        } = getState().roomtypes;

        let apiResponse = await post("", {
            query: LIST_ALL_ROOMTYPE_OTA_COUNT,
            variables: {
                pageSize: pageSize,
                pageNumber: pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_roomtype_ota_count: { data, hasMore },
            } = apiResponse.data.data;
            let updatedList = [...list, ...data];
            
            dispatch({
                type: SAVE_ALL_ROOMTYPE_OTA_COUNT,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: pageNumber + 1,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllRoomtypeOtaCount = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_ROOMTYPE_OTA_COUNT });
    };
};

export const addRoomtypeOtaCount = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_ROOMTYPE_OTA_COUNT,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomtypeOtaCount());
            dispatch(listAllRoomtypeOtaCount({ roomtypeId:requestData.roomtypeId }));
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const activateRoomtypeOtaCount = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ACTIVATE_ROOMTYPE_OTA_COUNT,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomtypeOtaCount());
            dispatch(listAllRoomtypeOtaCount({ roomtypeId:requestData.roomtypeId }));
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const syncRoomtypeOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: SYNC_ROOMTYPE_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomtypeOffers());
            dispatch(listAllRoomtypeOffers({ roomtypeId: requestData.roomtypeId }));
            toast.success("Data will be synced shortly!")
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const syncRoomtypeOtaCount = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: SYNC_ROOMTYPE_OTA_COUNT,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllRoomtypeOtaCount());
            dispatch(listAllRoomtypeOtaCount({ roomtypeId: requestData.roomtypeId }));
            toast.success("Data will be synced shortly!")
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const setDefaultMealPlan = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_DEFAULT_MEAL_PLAN,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            const updatedRoomType = apiResponse.data.data?.update_default_meal_plan?.updatedRoomType;

            if (updatedRoomType) {
                const { roomtypeDetails } = getState().admin;

                const updatedRoomtypeDetails = {
                    ...roomtypeDetails,
                    default_meal_plan_id: updatedRoomType.default_meal_plan_id,
                }

                dispatch({
                    type: SAVE_ROOMTYPE_DETAILS,
                    payload: updatedRoomtypeDetails,
                });
            }

            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
        return false;
    };
};

export const listAllPropertyOffers = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
        const propertyOffers = getState().roomtypes?.propertyOffers || {
            pageSize: 50,
            pageNumber: 1,
            list: [],
        };
        const { pageSize = 50, pageNumber = 1, list = [] } = propertyOffers;

        let apiResponse = await post("", {
            query: LIST_ALL_PROPERTY_OFFERS,
            variables: {
                pageSize: pageSize,
                pageNumber: pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_property_offers: { data, hasMore },
            } = apiResponse.data.data;
            let updatedList = [...(list || []), ...(data || [])];

            dispatch({
                type: SAVE_ALL_PROPERTY_OFFERS,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: pageNumber + 1,
                },
            });
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const resetAllPropertyOffers = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_PROPERTY_OFFERS });
    };
};

export const addNewPropertyOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_NEW_PROPERTY_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllPropertyOffers());
            dispatch(listAllPropertyOffers());
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const updatePropertyOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_PROPERTY_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllPropertyOffers());
            dispatch(listAllPropertyOffers());
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const activatePropertyOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ACTIVATE_PROPERTY_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllPropertyOffers());
            dispatch(listAllPropertyOffers());
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const syncPropertyOffer = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: SYNC_PROPERTY_OFFER,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllPropertyOffers());
            dispatch(listAllPropertyOffers());
            toast.success("Data will be synced shortly!");
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const checkPropertyOfferRates = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: CHECK_PROPERTY_OFFER_RATES,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                check_property_offer_rates,
            } = apiResponse.data.data;
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return check_property_offer_rates;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const listMokshaRoomtypeRates = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: LIST_MOKSHA_ROOMTYPE_RATES,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            let {
                list_moksha_roomtype_rates: { data },
            } = apiResponse.data.data;
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return data?.rates || [];
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const addMokshaRoomtypeRate = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_MOKSHA_ROOMTYPE_RATE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const updateMokshaRoomtypeRate = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_MOKSHA_ROOMTYPE_RATE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

export const activateMokshaRoomtypeRate = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ACTIVATE_MOKSHA_ROOMTYPE_RATE,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};
